import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Incident } from "../../models/incident.model";

@Injectable()
export class IncidentProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  report(data: any): Observable<Incident> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/incidents`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/incident/incident.ts